import Auth from '../api/auth';
import { noteServerTime } from './serverClock';

const parseErrorCode = error => Promise.reject(error);

const captureServerTime = response => {
  const headers = response?.headers;
  if (!headers) return response;

  noteServerTime(
    Number(headers['x-server-time']),
    Number(headers['x-server-offset'])
  );
  return response;
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => captureServerTime(response),
    error => {
      if (error?.response) captureServerTime(error.response);
      return parseErrorCode(error);
    }
  );
  return wootApi;
};
